import React, {Component} from "react";
import moment from "moment";
import Moment from "react-moment";
import {formatTimezoneLabelWithOffset, getTimezoneDataByName} from "../../utils/timezone";
import PropTypes from "prop-types";

export default class DateTimeWithTimezone extends Component {
  static propTypes = {
    time: PropTypes.string.isRequired,
    timezone: PropTypes.string.isRequired,
  };

  render() {
    const {time, timezone} = this.props;
    const dt = moment.tz(time, timezone);
    const timeZoneName = dt.tz();
    const timezoneData = getTimezoneDataByName(timeZoneName);
    return (
      <>
        {dt.format(Moment.timeFormat)}
        <br/>
        {timezoneData && formatTimezoneLabelWithOffset(timezoneData.label, dt.format('Z'))}
      </>
    )
  }
}
